import React from "react";
import { withRouter } from "react-router-dom";
import { ENV, MEMBER_BASEURL } from "./config/ApiConfig";
import SignupCallWizardEnrollment from "./SignupCallWizardEnrollment.js";
import SignupCallWizardConfirmation from "./SignupCallWizardConfirmation.js";

class SignupCall extends React.Component {
  inviteMap = {
    magellan: {
      code: "",
      route: "/call/magellan",
    },
    "magellan-nh": {
      code: "",
      route: "/call/magellan-nh",
    },
    "": {
      code: "",
      route: "/call",
    },
    unitedhealthcare: {
      code: "",
      route: "/call/unitedhealthcare",
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      errorMessage: false,
      firstName: "",
      lastName: "",
      birthDay: "",
      birthMonth: "",
      birthYear: "",
      email: "",
      phone: "",
      zip: "",
      id: "",
      reason: "",
      inviteCode: this.inviteMap[props.match.params.partner]?.["code"] ?? "",
      isTaskTransportationSelected: false,
      isTaskFoodNutritionSelected: false,
      isTaskHealthcareSelected: false,
      isTaskOtherSelected: false,
      wizardStep: "signup",
      termsAndPrivacyAccepted: false,
      throttleEnrollment: false,
      isEnrollmentSubmitting: false,
      partner: props.match.params.partner,
    };

    window.history.replaceState(null, "", this.inviteMap[props.match.params.partner ?? ""]["route"]);
    document.title = "Duos Sign Up";

    window.onbeforeunload = function () {
      return "Data will be lost if you leave the page, are you sure?";
    };

    // Re-routing to newer welcome sign up webpage.
    if (ENV === "prod") {
      window.location.href = "https://app.getduos.com/en/welcome";
    } else {
      window.location.href = "https://app.getduos.xyz/en/welcome";
    }
  }

  handleTaskSelection = (t) => {
    if (t === "transportation") {
      this.setState({
        isTaskTransportationSelected: !this.state.isTaskTransportationSelected,
      });
    } else if (t === "food") {
      this.setState({
        isTaskFoodNutritionSelected: !this.state.isTaskFoodNutritionSelected,
      });
    } else if (t === "healthcare") {
      this.setState({
        isTaskHealthcareSelected: !this.state.isTaskHealthcareSelected,
      });
    } else if (t === "other") {
      this.setState({ isTaskOtherSelected: !this.state.isTaskOtherSelected });
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "termsAndPrivacyAccepted") {
      this.setState({ [name]: event.target.checked });
    } else {
      this.setState({ [name]: value });
    }
  };

  handleCheckboxChange = (event) => {
    this.setState({ termsAndPrivacyAccepted: event.target.checked });
  };
  handleSelectChange = (event) => {
    this.setState({ caregiverRelationship: event.value });
  };

  validateForm = (_) => {
    // Depending on default browser validation and backend validation response until
    // we add custom client-size validation
    return true;
  };

  doEnrollment = (_) => {
    if (this.state.throttleEnrollment || this.state.isEnrollmentSubmitting) return;

    this.setState({
      errorMessage: false,
      throttleEnrollment: true,
      isEnrollmentSubmitting: true,
    });
    // Prevent double-submitting
    setTimeout(() => {
      this.setState({ throttleEnrollment: false });
    }, 2000);

    var combinedReason = "";
    if (this.state.isTaskTransportationSelected) combinedReason += "Transportation, ";
    if (this.state.isTaskFoodNutritionSelected) combinedReason += "Food & Nutrition, ";
    if (this.state.isTaskHealthcareSelected) combinedReason += "Healthcare, ";
    if (this.state.isTaskOtherSelected) combinedReason += "Other, ";
    combinedReason += this.state.reason;
    combinedReason = combinedReason.replace(/(^[,\s]+)|([,\s]+$)/g, "");

    const selfFields = {
      enrollmentType: "member",
      firstName: this.state.firstName.trim(),
      lastName: this.state.lastName.trim(),
      birthDay: this.state.birthDay.trim(),
      birthMonth: this.state.birthMonth.trim(),
      birthYear: this.state.birthYear.trim(),
      email: this.state.email.trim() === "" ? undefined : this.state.email.trim(),
      phone: this.state.phone.trim(),
      zipcode: this.state.zip.trim(),
      reason: combinedReason === "" ? undefined : combinedReason.trim(),
      inviteCode: this.state.inviteCode === "" ? undefined : this.state.inviteCode.trim(),
      termsAndPrivacyAccepted: this.state.termsAndPrivacyAccepted,
    };
    const requestBody = JSON.stringify(selfFields);

    const requestOptions = {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: requestBody,
    };
    fetch(MEMBER_BASEURL + "/v1/rest/enroll", requestOptions)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          switch (response.status) {
            case 404:
              console.log("Not found");
              throw Error("Enrollment failed");
            case 500:
              console.log("Internal server error");
              throw Error("Enrollment failed");
            case 401:
              console.log("Unauthorized");
              throw Error("Enrollment failed");
            case 400:
              response.json().then((err) => {
                // get errors from error body
                if (this.state.wizardStep === "signup") {
                  //console.log(err);
                  let errList = {};
                  for (var ii = 0; ii < err.length; ii++) {
                    errList[err[ii].field] = true;
                  }
                  this.setState({ errors: errList });
                }
              });
              throw Error("validation");
            default:
              console.log("Some error occurred error code = " + response.status);
              throw Error("Enrollment failed");
          }
        }
      })
      .then((responseData) => {
        this.setState({ errors: {}, isEnrollmentSubmitting: false });
        if (this.state.wizardStep === "signup") {
          //console.log("Enrollment Successful! Response data:");
          if (responseData === "covered") {
            this.setWizardStep("thank-you");
          } else if (responseData === "enrolled") {
            this.setWizardStep("thank-you");
            window.scrollTo(0, 0);
          } else {
            // TODO: show error message in UI to indicate failed enrollment
            //console.log("Enrollment status returned with failure");
          }
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ isEnrollmentSubmitting: false });
        if (error.message !== "validation") this.setState({ errorMessage: true });
      });
  };

  handleEnrollmentSubmit = (event) => {
    event.preventDefault();
    // TODO Form Validation
    if (!this.validateForm()) {
      //console.log("Form validation failed");
      return;
    }
    this.doEnrollment();
  };

  errorHandler = (e) => {
    return this.state.errors[e] ? { borderColor: "red", filter: "drop-shadow(0px 0px 3px red)" } : {};
  };

  setWizardStep = (s) => {
    this.setState({ wizardStep: s });
    window.scrollTo(0, 0);
    window.history.replaceState(null, "", "/call/" + s);
    document.title = "Duos Sign Up - " + s.charAt(0).toUpperCase() + s.slice(1);
  };

  render() {
    return (
      <div>
        <SignupCallWizardEnrollment
          state={this.state}
          handleChange={this.handleChange}
          handleCheckboxChange={this.handleCheckboxChange}
          handleSelectChange={this.handleSelectChange}
          handleTaskSelection={this.handleTaskSelection}
          errorHandler={this.errorHandler}
          handleEnrollment={this.handleEnrollmentSubmit}
        />
        <SignupCallWizardConfirmation state={this.state} />
      </div>
    );
  }
}

export default withRouter(SignupCall);
